import useFormValue from '@src/hooks/useFormValue';
import {useContext} from 'react';
import {FormFieldItemPropsContext} from '@src/contexts/FormFieldItemPropsContext';
import {FormFieldOption} from '@src/@types/components/Form';
import {IProductModel} from '@src/@interfaces/models/Product/IProductModel';

export default function useSelectedProduct(productNamePrefix: string) {
    const {currentValue: activeProductId} = useFormValue(`${productNamePrefix}.product_id`);

    const {modelOptions = {}} = useContext(FormFieldItemPropsContext) ?? {};
    const activeProduct: FormFieldOption & IProductModel | null = activeProductId ?
        modelOptions.products?.find(item => item.value === activeProductId) as any ?? null :
        null;

    return activeProduct;
}
